






















































































































































































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "@/lib/util";
import AbpBase from "@/lib/abpbase";
import Invoice from "@/store/entities/invoice";
import VueBarcode from 'vue-barcode';
import Print from 'vue-print-nb'
import moment from "vue-moment";
Vue.use(Print);
@Component({
    components:{ 'barcode': VueBarcode}
})
export default class PrinterInvoice extends AbpBase{
  @Prop({ type: Boolean, default: false }) value: boolean;
  @Prop({ type: Number, default: 1 }) width: number;
  @Prop({ type: Number, default: 30 }) height: number;
  @Prop({ type: String, default: "svg" }) type: String;
  @Prop({ type: String, default: "Arial" }) font: String;
  @Prop({ type: String, default: "12" }) fontSize: String;
  code : string = '';
  contactNumber : string = '1';
  options:any= {
      format: 'CODE128',
      background: '#fff'
  }
  currentDate: Date = new Date();
  invoiceOrder : Invoice = new Invoice();

  async getDataInvoice(){
  }

  get loading(){
      return false;
  }

  columns=[
    {
        title:this.L('STT'),
        width:40,
        align: "center",
        key:'orderNo'
    },{
        title:this.L('Tên dịch vụ - hàng hóa'),
        width:150,
        align: "left",
        key:'productName'
    },{
        title:this.L('Mã số'),
        width:140,
        align: "left",
        key:'sku'
    },
    {
        title:this.L('Đơn vị tính'),
        width:90,
        align: "left",
        key:'unitName'
    },
    {
        title:this.L('Số lượng'),
        width:89,
        align: "right",
        key:'orderQty'
    },
    {
        title:this.L('Đơn giá'),
        width:90,
        align: "right",
        key:'price'
    },
    {
        title:this.L('Thành tiền'),
        width:99,
        align: "right",
        key:'money'
    },
  ]

  handleSummary({columns, data}){
    const sums = {};

    columns.forEach((column, index) => {
      const key = column.key;
      if(index == 0){
        sums[key] = {
          key,
          value : "Tổng cộng"
        };
        return;
      }
      if(index == 6){
        sums[key] = {
          key,
          value : this.invoiceOrder.sumMoney
        };
        return;
      }

      return sums;
    });
  }

  async created(){
    this.code = this.$root.$router.currentRoute.params.code;
    this.contactNumber = this.$root.$router.currentRoute.params.contactNumber;
    await this.$store
      .dispatch({
          type:'saleOrder/getInvoice',
          data: { code : this.code, contactNumber : this.contactNumber}
      })
      .then(() => {
        this.invoiceOrder = this.$store.state.saleOrder.invoice;
        var index = 0;
        if(this.invoiceOrder.items != undefined){
          this.invoiceOrder.items.forEach(function(item) {
            item.orderNo = index + 1;
            index++;
          });
        }

      });
  }
}
